"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionDuration = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useAnimationState = require("../../utils/use-animation-state");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../utils/use-isomorphic-layout-effect"));
var _theme = require("../theme");
var _ripple = _interopRequireDefault(require("../ripple"));
require("./frap.css");
var _excluded = ["centerSvgInMiniFrap", "children", "circular", "className", "color", "disabled", "href", "loading", "loadingAriaLiveAnnouncement", "mini", "onClick", "style", "tagName"];
/* eslint-disable complexity */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var transitionDuration = exports.transitionDuration = 200;

/* eslint-disable max-statements */
/**
 * A FRAP (Floating Resizable Action Pill) is a continuation of Material Design's [FAB: Floating Action Button](https://material.io/guidelines/components/buttons-floating-action-button.html). Unlike the FAB, it includes clear text, never an icon, in order to make every action clear and unambigous.
 *
 * It's a button-like element that is typically the primary action forward in a
 * screen/workflow. It persistently conveys a user's next best action by floating at
 * the highest possible element elevation, always locked to the bottom right of the screen.
 *
 * The FRAP and Mini FRAP can be paired to deliver two distinct and immediately available
 * actions at key points within the order flow. Mini FRAPs have the same elevation and interactive
 * properties as FRAPS, however they may contain an icon or sometimes an icon paired with text.
 *
 * Like `Button`, it renders `button` tags by default or `a` if `href` is
 * provided. It also supports an arbitrary `tagName` prop for advanced usage, which can
 * support HTML tag names or React components like `Link`.
 */
var Frap = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$centerSvgInMiniF = _ref.centerSvgInMiniFrap,
    centerSvgInMiniFrap = _ref$centerSvgInMiniF === void 0 ? true : _ref$centerSvgInMiniF,
    children = _ref.children,
    circular = _ref.circular,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'greenAccent' : _ref$color,
    disabled = _ref.disabled,
    href = _ref.href,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$loadingAriaLiveA = _ref.loadingAriaLiveAnnouncement,
    loadingAriaLiveAnnouncement = _ref$loadingAriaLiveA === void 0 ? 'Loading' : _ref$loadingAriaLiveA,
    _ref$mini = _ref.mini,
    mini = _ref$mini === void 0 ? false : _ref$mini,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    style = _ref.style,
    tagName = _ref.tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var frapRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return frapRef.current;
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAnimating = _useState2[0],
    setIsAnimating = _useState2[1];
  var animationState = (0, _useAnimationState.useAnimationState)(isAnimating, transitionDuration);
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    styleState = _useState4[0],
    setStyleState = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingContent = _useState6[0],
    setLoadingContent = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    naturalHeight = _useState8[0],
    setNaturalHeight = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    naturalWidth = _useState10[0],
    setNaturalWidth = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    timer = _useState12[0],
    setTimer = _useState12[1];
  (0, _react.useEffect)(function () {
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);
  var showLoadingIcon = function showLoadingIcon() {
    setLoadingContent(/*#__PURE__*/_react["default"].createElement("span", {
      className: "sb-frap--loadingCircle"
    }));
  };
  (0, _useIsomorphicLayoutEffect["default"])(function () {
    if (loading && !isAnimating) {
      var _frapRef$current;
      var _frapRef$current$getB = (_frapRef$current = frapRef.current) === null || _frapRef$current === void 0 ? void 0 : _frapRef$current.getBoundingClientRect(),
        height = _frapRef$current$getB.height,
        width = _frapRef$current$getB.width;
      // set explicit width so CSS transition will work
      setStyleState({
        width: width,
        height: height
      });
      // capture natural dimensions for use later
      setNaturalHeight(height);
      setNaturalWidth(width);
      setIsAnimating(true);
    }
    if (!loading && isAnimating) {
      // reverse the animation
      setIsAnimating(false);
    }
  }, [loading, isAnimating]);
  (0, _useIsomorphicLayoutEffect["default"])(function () {
    if (animationState === _useAnimationState.states.opening) {
      var _frapRef$current2;
      // In some cases, React seems to skip setting the 'naturalWidth' style in the first
      // layout effect, resulting in no transition to the 'loading' size.
      // For some reason, simply accessing the DOM element here forces
      // a repaint with both states (we call getBoundingClientRect but don't need the result).
      // There is undoubtedly a way to handle this more purely in an effect,
      // but I haven't figured out how.
      (_frapRef$current2 = frapRef.current) === null || _frapRef$current2 === void 0 || _frapRef$current2.getBoundingClientRect();
      // Set the loading width the same as height to draw a circular button.
      setStyleState({
        width: naturalHeight,
        height: naturalHeight,
        padding: 0
      });
      // clear the content so text is not scrunched during animation...
      setLoadingContent(null);
      // ...and then show the loading icon once the transition is nearly complete.
      setTimer(setTimeout(function () {
        return showLoadingIcon();
      }, transitionDuration * 0.75));
    }
    if (animationState === _useAnimationState.states.closing) {
      setStyleState({
        width: naturalWidth,
        height: naturalHeight
      });
      // don't show any content while in transition
      setLoadingContent(null);
    }
    if (animationState === _useAnimationState.states.closed) {
      // clear any styling to permit inherent sizes to take over
      setStyleState();
    }
  }, [animationState]);
  var isInLoadingState = isAnimating || animationState === _useAnimationState.states.closing;

  // Don't use default props for tagName because default is conditional based on presence
  // of href.
  var TagName = tagName || (href ? 'a' : 'button');
  var frapOnClick = !loading ? onClick : function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  };
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    return /*#__PURE__*/_react["default"].createElement(_ripple["default"], {
      containerRef: frapRef,
      dark: mini || color === 'white' ? true : false
    }, function (_ref2) {
      var ripple = _ref2.ripple,
        mergeEventHandlers = _ref2.mergeEventHandlers;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-live": "polite",
        className: "hiddenVisually"
      }, loading ? loadingAriaLiveAnnouncement : ''), /*#__PURE__*/_react["default"].createElement(TagName, _extends({
        "aria-disabled": disabled,
        className: (0, _classnames["default"])(className, 'sb-frap', {
          'sb-frap--rewardsDefault': theme === _theme.themes.rewards,
          'sb-frap--darkTheme': theme === _theme.themes.dark,
          'sb-frap--mini': mini,
          'sb-frap--circular': circular,
          'sb-frap--disabled': disabled,
          'sb-frap--centerSVG': centerSvgInMiniFrap,
          'sb-frap--white': color === 'white',
          'sb-frap--houseGreen': color === 'houseGreen'
        }),
        href: href,
        onClick: frapOnClick,
        ref: frapRef,
        style: _objectSpread(_objectSpread({}, style), styleState)
      }, otherProps, mergeEventHandlers({
        onTouchStart: otherProps === null || otherProps === void 0 ? void 0 : otherProps.onTouchStart,
        onMouseDown: otherProps === null || otherProps === void 0 ? void 0 : otherProps.onMouseDown
      })), isInLoadingState ? loadingContent : children, !disabled && !loading && ripple));
    });
  });
});
Frap.displayName = 'Frap';
Frap.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If true, SVG will be centered inside the frap.
   */
  centerSvgInMiniFrap: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  /**
   * If true, sets a circular background behind the actual element.
   */
  circular: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  /**
   * Sets background color to either green accent, house green, or white. Defaults to green accent.
   * Text color will be set based on which option is chosen.
   */
  color: _propTypes["default"].oneOf(['greenAccent', 'white', 'houseGreen']),
  disabled: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  /**
   * Text that will be read aloud by a screen reader to announce that the button is in a loading state.
   */
  loadingAriaLiveAnnouncement: _propTypes["default"].any,
  /**
   * If true, it shows a loading animation inside the frap. Not shown if it's a mini frap
   * or it's disabled.
   */
  loading: _propTypes["default"].bool,
  /**
   * If true, limits height and changes foreground/background colors.
   */
  mini: _propTypes["default"].bool,
  /**
   * Permits use of any HTML element or React component as a frap. Defaults to `button`,
   * or `a` if an `href` is present.
   */
  tagName: _propTypes["default"].any
} : {};
var _default = exports["default"] = Frap;